<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M2545.3 2857.54l-746.14 -449.81 -746.15 449.81 197.54 -848.41 -657.94 -569.74 867.88 -74.14 338.67 -800.81 338.67 799.08 867.88 74.07 -657.95 569.74 197.54 850.21 0 0zm-746.14 -2822.23c-975.42,0 -1763.89,793.74 -1763.89,1763.88 0.06,973.95 789.94,1763.82 1763.89,1763.82 974.01,0 1763.89,-789.87 1763.89,-1763.82 0,-974.01 -789.88,-1763.88 -1763.89,-1763.88z"/>
  </g>
 </g>
</svg>
